import React, { Component } from "react";
import { connect } from "react-redux";
import { getServers, updateServer, deleteServer, destroyAgentKasms, setAgentPageInfo } from "../../actions/actionServer";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader, Progress } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import moment from "moment";
import { Link, withRouter } from "react-router-dom";
import Select from "react-select";
import "react-select/dist/react-select.css";

const routes = [
    { name: "Home", path: "/userdashboard", isActive: false },
    { name: "Agents", path: "/servers", isActive: true }
];

class Agents extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            pages: 1,
            serverId: null,
            server_type: 'Desktop',
            serversModal: false,
            selectedServers: [],
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.destroyKasmsConfirm = this.destroyKasmsConfirm.bind(this);
        this.deleteServerAction = this.deleteServerAction.bind(this);
        this.destroyKasmsAction = this.destroyKasmsAction.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.cancelDestroy = this.cancelDestroy.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.handleDestroyKasmSuccess = this.handleDestroyKasmSuccess.bind(this);
        this.handleDestroyKasmError = this.handleDestroyKasmError.bind(this);
        this.assignServer = this.assignServer.bind(this);
        this.cancelServersModal = this.cancelServersModal.bind(this);
        this.handleChangeServers = this.handleChangeServers.bind(this);

    }

    componentDidMount() {
        this.props.getServers();
    }

    handleChangeServers(selectedServers) {
        this.setState({ selectedServers });
    }

    deleteConfirm(serverId) {
        this.setState({ modal: !this.state.modal, serverId: serverId });
    }

    destroyKasmsConfirm(serverId) {
        this.setState({ destroyModal: !this.state.destroyModal, serverId: serverId });
    }

    cancelDestroy() {
        this.setState({ destroyModal: !this.state.destroyModal });
    }

    cancelDelete() {
        this.setState({ modal: !this.state.modal });
    }

    cancelServersModal() {
        this.setState({ serversModal: !this.state.serversModal });
    }

    async assignServer() {
        await Promise.all(this.state.selectedServers.map(async server => {
            const serverToUpdate = this.props.servers.find(all => all.server_id === server.value)
            serverToUpdate.server_pool_id = this.props.pool
            await this.props.updateServer(serverToUpdate)
        }))

        this.props.getServers()
        this.setState({ selectedServers: [], serversModal: false });
    }

    deleteServerAction() {
        this.props.deleteServer(this.state.serverId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    destroyKasmsAction() {
        this.props.destroyAgentKasms(this.state.serverId).
            then(() => this.handleDestroyKasmSuccess()).
            catch(() => this.handleDestroyKasmError());
    }

    handleDeleteSuccess() {
        const { deleteServerErrorMessage } = this.props;
        if (deleteServerErrorMessage) {
            NotificationManager.error(deleteServerErrorMessage, "Delete Server", 3000);
            this.setState({ modal: false });
        }
        else {
            NotificationManager.success("Successfully Deleted Server", "Delete Server", 3000);
            this.setState({ modal: false });
            this.props.getServers();
        }
    }

    handleDeleteError() {
        const { deleteServerError } = this.props;
        if (deleteServerError) {
            NotificationManager.error(deleteServerError, "Delete Server", 3000);
            this.setState({ modal: false });
        }
        else {
            NotificationManager.error("Failed to Delete Server", "Delete Server", 3000);
            this.setState({ modal: false });
        }
    }

    handleDestroyKasmSuccess() {
        const { destroyAgentKasmsErrorMessage } = this.props;
        if (destroyAgentKasmsErrorMessage) {
            NotificationManager.error(destroyAgentKasmsErrorMessage, "Delete Sessions", 3000);
            this.setState({ destroyModal: false });
        }
        else {
            NotificationManager.success("Successfully marked Sessions for deletion", "Delete Sessions", 3000);
            this.setState({ destroyModal: false });
            this.props.getServers();
        }
    }

    handleDestroyKasmError() {
        const { destroyAgentKasmsError } = this.props;
        if (destroyAgentKasmsError) {
            NotificationManager.error(destroyAgentKasmsError, "Delete Sessions", 3000);
            this.setState({ destroyModal: false });
        }
        else {
            NotificationManager.error("Failed to mark Sessions for deletion", "Delete Sessions", 3000);
            this.setState({ destroyModal: false });
        }
    }

    render() {
        if (this.props.getServersLoading) {
            return (<div> <LoadingSpinner /></div>);
        }


        const { servers } = this.props;
        let filtered_servers = servers.filter(x => x.server_type.toLowerCase() === this.state.server_type.toLowerCase())
        let unattached_servers = [
            ...filtered_servers
        ]

        if (this.props.pool) {
            unattached_servers = unattached_servers.filter(config => config.server_pool_id !== this.props.pool)
            filtered_servers = filtered_servers.filter(config => config.server_pool_id === this.props.pool)
        }

        let optionsServers = [];
        unattached_servers.map(opt => {
            optionsServers.push({ label: opt.friendly_name, value: opt.server_id });
        });


        const columns = [
            {
                type: "text",
                name: "Friendly Name",
                accessor: "friendly_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Hostname",
                accessor: "hostname",
                filterable: true,
                sortable: true,
            },
            {
                type: "date",
                accessor: "created",
                name: "Created",
                filterable: true,
                sortable: true,
                cell: (data) => <div>{moment(data.value).isValid() ? moment.utc(data.value).local().format("L h:mm A") : "-"}</div>
            },
            {
                type: "text",
                name: "Server Id",
                accessor: "server_id",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Connection Type",
                accessor: "connection_type",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Status",
                accessor: "operational_status",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Enabled",
                accessor: "enabled",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Zone",
                accessor: "zone.zone_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Sessions",
                accessor: "kasms.length",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Provider",
                accessor: "provider",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Pool",
                accessor: "server_pool_name",
                filterable: true,
                sortable: true,
            },
        ];


        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete-server", icon: "fa-trash", description: "Delete Server" },
            { id: "delete-sessions", icon: "fa-trash", description: "Delete Sessions" },
        ];

        const haspool = (this.props.pool) ? '?pool=' + this.props.pool : ''

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/view_server/${item.server_id}`);
                    break;

                case "edit":
                    this.props.history.push(`/update_server/${item.server_id}${haspool}`);
                    break;

                case "delete-server":
                    this.deleteConfirm(item.server_id);
                    break;

                case "delete-sessions":
                    this.destroyKasmsConfirm(item.server_id);
                    break;
            }
        }

        let agentStyle = "btn btn-outline-primary btn-block ";
        let desktopStyle = "btn btn-outline-primary btn-block";

        const create_link = {
            pathname: "/create_server"
        }
        if (this.props.pool) {
            create_link.search = '?pool=' + this.props.pool
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes} />
                <Row>
                    <Col sm={{ size: this.props.pool ? 8 : 10, order: 3, offset: this.props.pool ? 2 : 1 }}>
                        <Card >
                            <CardHeader>
                                <div className="title-head">
                                    <Link className='tw-text-color' to={{ pathname: "/servers" }}><i className="fa fa-server"></i> <strong>Servers</strong></Link></div>
                                <Row>
                                    <Col>
                                        <Link className="pull-right add-btn" to={create_link}>
                                            <button className="pull-right adduser-btn" size="sm" color="dark">
                                                <i className="fa fa-plus" aria-hidden="true"></i>
                                                Add
                                            </button>
                                        </Link>
                                        {this.props.pool && (
                                            <div className="pull-right add-btn tw-mr-3">
                                                <button onClick={() => this.setState({ serversModal: true })} className="pull-right adduser-btn !tw-bg-[#181f471a] tw-text-color dark:!tw-bg-[#363d5d] dark:tw-text-white" size="sm" color="dark">
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                    Assign
                                                </button>
                                            </div>

                                        )}
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="agents"
                                    data={filtered_servers}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>


                <Modal isOpen={this.state.serversModal} toggle={this.cancelServersModal} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelServersModal}>Assign Existing Server(s) To This Pool
                    </ModalHeader>
                    <ModalBody>

                        <Select
                            name="servers"
                            multi={true}
                            options={optionsServers}
                            value={this.state.selectedServers}
                            onChange={this.handleChangeServers}
                        />


                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelServersModal}
                            className="cancel-button"
                            size="sm" color="basic"> Close</Button>
                        <Button onClick={this.assignServer}
                            className="submit-button"
                            size="sm" color="success"> Assign</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this Server?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete}
                            className="cancel-button"
                            size="sm" color="basic"> Close</Button>
                        <Button onClick={this.deleteServerAction}
                            className="delete-button"
                            size="sm" color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.destroyModal} toggle={this.cancelDestroy} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDestroy}>Are you sure you want to delete this sessions?
                    </ModalHeader>
                    <ModalBody className="confirm-modal-body">
                        Sessions that reside on this Server will be marked for deletion. They will be destroyed in a few moments.
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelDestroy} className="cancel-button" size="sm" color="basic"> Close</Button>
                        <Button className="delete-button" onClick={this.destroyKasmsAction} size="sm" color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Agents.propTypes = {
    getServers: Proptypes.func.isRequired,
    deleteServer: Proptypes.func.isRequired,
    destroyAgentKasms: Proptypes.func.isRequired,
    deleteServerError: Proptypes.func,
    destroyAgentKasmsError: Proptypes.func,
    servers: Proptypes.array,
    getServersLoading: Proptypes.bool,
    deleteServerErrorMessage: Proptypes.func,
    destroyAgentKasmsErrorMessage: Proptypes.func,
    className: Proptypes.func
};

let AgentsWithRouter = withRouter(Agents);


export default connect(state =>
({
    servers: state.servers.servers || [],
    deleteServerErrorMessage: state.servers.deleteServerErrorMessage || null,
    destroyAgentKasmsErrorMessage: state.servers.destroyAgentKasmsErrorMessage || null,
    getServersLoading: state.servers.getServersLoading || false,
    deleteServerError: state.servers.deleteServerError || null,
    destroyAgentKasmsError: state.servers.destroyAgentKasmsError || null,
    pages: { pageSize: state.servers.pageSize, pageNo: state.servers.pageNo },


}),
    dispatch =>
    ({
        getServers: () => dispatch(getServers()),
        deleteServer: (data) => dispatch(deleteServer(data)),
        destroyAgentKasms: (data) => dispatch(destroyAgentKasms(data)),
        setPageInfo: (data) => dispatch(setAgentPageInfo(data)),
        updateServer: (data) => dispatch(updateServer(data)),
    }))(AgentsWithRouter);